module.exports = __webpack_public_path__ + "static/media/marketplace.99173b88.jpeg";